import { useCustomConfirm } from "../../alerts";
import { useAppDispatch, useAppSelector } from "../../store";
import { useCallback, useContext, useEffect, useState } from "react";
import {
  addUserToBoard,
  pageFailure,
} from "../../../../reducers/uploadedBoard";
import useChangeBoardOwner from "./changeBoardOwner";
import { DEMO_BOARD_SLUG } from "../../../../constants/boards";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../group";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "./state-machine/reviewBoardFlowLoader";

export default function useAutomaticallyAddUserToBoard() {
  const { boardId: contextBoardId } = useContext(
    BoardIdContext,
  ) as BoardShipmentIds;
  const customConfirm = useCustomConfirm();
  const dispatch = useAppDispatch();
  const errorHandler = useCallback(() => {
    if (contextBoardId) {
      dispatch(pageFailure({ boardId: contextBoardId }));
    }
  }, [dispatch, contextBoardId]);
  const boardId = useAppSelector((state) =>
    contextBoardId
      ? state.uploadedBoard.boards[contextBoardId]?.board?.id || null
      : null,
  );
  const boardOwnerId = useAppSelector((state) =>
    contextBoardId
      ? state.uploadedBoard.boards[contextBoardId]?.board?.user_id || null
      : null,
  );

  const [preventAddBoardToAccount, setPreventAddBoardToAccount] =
    useState(false);
  const { signedIn, groups, userId, email } = useAppSelector(
    (state) => state.auth,
  );

  const addUserHandler = useCallback(() => {
    if (contextBoardId) {
      dispatch(
        addUserToBoard({ boardId: contextBoardId, userId: userId as string }),
      );
    }
  }, [dispatch, userId, contextBoardId]);

  const { changeBoardOwner, changingOwner } = useChangeBoardOwner(
    errorHandler,
    addUserHandler,
  );

  useEffect(() => {
    if (
      boardId != DEMO_BOARD_SLUG &&
      boardId !== null &&
      signedIn &&
      email !== null &&
      boardOwnerId === null &&
      !changingOwner &&
      !preventAddBoardToAccount
    ) {
      if (groups.includes(ADMIN_GROUP) || groups.includes(ENGINEER_GROUP)) {
        customConfirm(
          "This board is currently anonymous, possibly because we are preparing it for a customer. Do you want to associate this board with your account? This will prevent customers from seeing it unless you share it or anonymize it again.",
          () => {
            changeBoardOwner(email, boardId);
          },
          () => {
            setPreventAddBoardToAccount(true);
          },
        );
      } else {
        changeBoardOwner(email, boardId);
      }
    }
  }, [
    boardId,
    boardOwnerId,
    changeBoardOwner,
    changingOwner,
    customConfirm,
    groups,
    preventAddBoardToAccount,
    signedIn,
    email,
  ]);
}
